import classNames from 'classnames'
import { ReactNode } from 'react'
import Icon from '../icon'

export const ActionChip = ({
  icon,
  name,
  onDismiss,
  onClick,
  iconClassName,
  className,
}: {
  icon?: string
  name: ReactNode
  onDismiss?: () => void
  onClick?: () => void
  iconClassName?: string
  className?: string
}) => {
  return (
    <div
      className={classNames(
        `
        text-sm rounded-md
        py-2 px-2.5
        bg-gray-bg
        flex gap-2 items-center
        `,
        {
          'cursor-pointer': onClick !== undefined,
        },
        className,
      )}
      onClick={onClick}
    >
      {icon && (
        <img
          src={icon}
          className={`block w-[48px] h-[48px] object-cover rounded-md ${iconClassName}`}
          alt={`icon`}
        />
      )}

      {name}

      {onDismiss && (
        <button
          className="text-primary"
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            onDismiss()
          }}
        >
          <Icon id="close-circle" width={24} height={24} />
        </button>
      )}
    </div>
  )
}
